import { setTheme } from "theme/default/setTheme";

export const color_3a8fda = setTheme(({ theme }) => theme.colors.color_3a8fda);
